// haupt-einstiegspunkt der vue-anwendung
// initialisiert vue, router, pinia und firebase
// verbindet mit firebase emulatoren im entwicklungsmodus
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import { router } from './router'

// deaktiviere console-logs in production
// in der deployed version sollen keine logs in der konsole erscheinen
if (process.env.NODE_ENV === 'production') {
  // überschreibe alle console-methoden mit no-op funktionen
  console.log = () => {}
  console.error = () => {}
  console.warn = () => {}
  console.info = () => {}
  console.debug = () => {}
}

// importiere die benötigten funktionen aus den firebase sdks
import { initializeApp } from "firebase/app"
import { getAnalytics } from "firebase/analytics"
import { getAuth, connectAuthEmulator } from "firebase/auth"
import { USE_EMULATOR, EMULATOR_PORTS } from './config/firebase'

// firebase konfiguration für die web-app
// diese daten verbinden die app mit dem firebase-projekt
const firebaseConfig = {
  apiKey: "AIzaSyB6OCtJmX2g6QroKIPMAQMPO8Zt-6Zawn0",
  authDomain: "bbb-58f62.firebaseapp.com",
  projectId: "bbb-58f62",
  storageBucket: "bbb-58f62.firebasestorage.app",
  messagingSenderId: "624411856402",
  appId: "1:624411856402:web:88d9fc237dd424b0e6d2cb",
  measurementId: "G-75ZEX5TV5X"
};

// initialisiere firebase mit der konfiguration
const firebaseApp = initializeApp(firebaseConfig)

// verbinde mit auth emulator wenn konfiguriert
// emulatoren ermöglichen lokale entwicklung ohne cloud-verbindung
if (USE_EMULATOR) {
  try {
    const auth = getAuth(firebaseApp)
    // prüfe ob bereits verbunden (verhindert fehler bei hot reload)
    const isAlreadyConnected = auth._delegate?._config?.emulator || 
                                auth._delegate?._settings?.host?.includes('localhost')
    
    // wenn noch nicht verbunden, verbinde mit emulator
    if (!isAlreadyConnected) {
      connectAuthEmulator(auth, `http://localhost:${EMULATOR_PORTS.auth}`, { disableWarnings: true })
      console.log(`✅ Verbunden mit Firebase Auth Emulator (localhost:${EMULATOR_PORTS.auth})`)
    }
  } catch (error) {
    // wenn emulator nicht verfügbar, verwende cloud (nur warnung, kein fehler)
    console.warn('⚠️ Auth Emulator nicht verfügbar, verwende Firebase Cloud:', error.message)
  }
} else {
  console.log('🌐 Verwende Firebase Cloud Service')
}

// initialisiere analytics (optional, kann später verwendet werden)
// analytics sammelt nutzungsstatistiken der app
// verwende try-catch, damit die app auch ohne analytics funktioniert
try {
  getAnalytics(firebaseApp)
} catch (error) {
  // analytics ist optional, app sollte auch ohne funktionieren
  console.warn('Analytics konnte nicht initialisiert werden:', error)
}

// test-hilfsfunktionen importieren (nur in entwicklung)
// diese funktionen werden in der browser-konsole verfügbar gemacht
if (process.env.NODE_ENV === 'development') {
  import('./utils/testHelpers.js')
}

// erstelle die vue-app-instanz mit fehlerbehandlung
// damit die app auch bei fehlern startet
try {
  const app = createApp(App)
  // verwende pinia für state management (zustandsverwaltung)
  app.use(createPinia())
  // verwende den router für navigation
  app.use(router)
  // mounte die app auf das html-element mit id="app"
  app.mount('#app')
} catch (error) {
  // zeige fehler in der konsole und auf der seite
  console.error('Fehler beim Starten der App:', error)
  // zeige benutzerfreundliche fehlermeldung
  const appElement = document.getElementById('app')
  if (appElement) {
    appElement.innerHTML = `
      <div style="padding: 2rem; text-align: center; font-family: sans-serif;">
        <h1 style="color: #dc2626; margin-bottom: 1rem;">Fehler beim Laden der Anwendung</h1>
        <p style="color: #666; margin-bottom: 0.5rem;">Es ist ein Fehler aufgetreten. Bitte lade die Seite neu.</p>
        <p style="color: #999; font-size: 0.9rem;">Fehler: ${error.message || 'Unbekannter Fehler'}</p>
      </div>
    `
  }
}